import WorkspaceLogoBase from './WorkspaceLogo'
import WorkspaceLogoIcon from './WorkspaceLogoIcon'
import { Wrapper } from './WorkspaceLogo.styles'

export { Wrapper }

export const WorkspaceLogo = Object.assign(WorkspaceLogoBase, {
  Icon: WorkspaceLogoIcon,
})
